import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Platform, TouchableOpacity, ActivityIndicator, FlatList, Dimensions } from 'react-native';
import { Flex, Padding, Margin, Helpers, Typo, appStyles, postSingle, article, FontFamily, Colors } from '../../styles/appStyles';
import { helpers } from '../../utils/helpers';
import apiHelpers from "../../utils/api-helpers";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Cookies from "universal-cookie";
import { removeUserToken } from '../../../redux/User/user.actions';
import TouchableOpacityLink from '../touchable-opacity-link';
import ArticleItem from '../article-item';
import PageBreak from '../page-break';
import getImagePath from '../../utils/image-helper';
import CustomImage from '../custom-image';
import AuthenticationWrapper from '../authentication-wrapper';

const cookies = new Cookies();
const reading = getImagePath('icons/reading-list-icon.png');
const readingDark = getImagePath('icons/reading-list-light.png');

const aiReadingListIcon = getImagePath('img/reading-list-back.png');
const bookmarkIcon = getImagePath('icons/bookmark.png');
const bookmarkIconLight = getImagePath('icons/bookmark-light.png');

const bookmarkMultiple = getImagePath('icons/bookmark-multiple-light.png');
const bookmarkMultipleDark = getImagePath('icons/bookmark-multiple-white.png');

export class HomeReadingList extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const {isAuthenticated, fetchToken} = this.props.auth
        let token = webView ? (isAuthenticated?fetchToken:false) : this.props.user?.userData?.data?.token;
        this.state = {
        }
    }

    componentDidMount = () => {
    }

    viewArticle = (catSlug, slug, postData) => {
        const { viewArticle } = this.props;
        viewArticle(catSlug, slug, postData)
    }

    viewAuthor = (slug) => {
        const { viewAuthor } = this.props;
        viewAuthor(slug)
    }

    render() {
        const { data, darkMode } = this.props;
        let fullReadingListProp;
        if (helpers.isWeb()) {
            fullReadingListProp = {
                to: "/bookmarks"
            };

        } else {
            fullReadingListProp = {
                onPress: () => this.props.navigateApp('/bookmarks')
            }
        }
        return (
            <View style={{ paddingBottom: 40, backgroundColor: darkMode ? '#1E1E1E' : '#f8f8f8', marginTop: 30, height: helpers.isWeb() ? 'fit-content' : '100%', width: helpers.isDesktop() ? '29%' : '100%' }}>
                <View style={[Margin.mt_2, Flex.row, Flex.alignCenter, { paddingHorizontal: 20, paddingBottom: 20, borderBottomWidth: 2, borderBottomColor: darkMode ? Colors.lineColor : '#000' }]}>
                    <CustomImage
                        source={darkMode ? bookmarkMultipleDark : bookmarkMultiple}
                        require={true}
                        style={{ width: 18, height: 23 }}
                        webStyle={{ width: helpers.isDesktop() ? 'auto' : 15, height: helpers.isDesktop() ? 28 : 'auto', }}
                        resizeMode={'contain'}
                    />
                    <Text style={[Typo.h2, Padding.pl_1, { fontFamily: FontFamily.abrilFatface, fontSize: helpers.isDesktop() ? 24 : 18, lineHeight: helpers.isDesktop() ? 29 : 22, paddingHorizontal: 20, color: '#000' }, darkMode && { color: 'rgba(255,255,255,0.87)' }]}>Bookmarks</Text>
                </View>
                <View style={{ paddingHorizontal: 20, paddingTop: 20 }}>
                    {data && data.length != 0 ?
                        data.map((item, index) => {
                            return <ArticleItem viewArticle={(catSlug, slug, postData) => this.viewArticle(catSlug, slug, postData)} viewAuthor={(slug) => this.viewAuthor(slug)} data={item} single={index == 0 ? true : false} home={true} homereadinglist={true} hideDate={true} darkMode={darkMode} />
                        })
                        :
                        <View>
                            <Text style={{ color: darkMode ? 'rgba(255,255,255,0.87)' : 'rgba(0, 0, 0, 0.9)', fontSize: helpers.isDesktop() ? 20 : 18, lineHeight: helpers.isDesktop() ? 28 : 22, fontFamily: FontFamily.regular, fontWeight: '500' }}>You haven’t saved anything yet</Text>

                            <View style={[Margin.mt_1]}>
                                <Text style={{ color: darkMode ? 'rgba(255,255,255,0.87)' : 'rgba(0, 0, 0, 0.9)', fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: helpers.isDesktop() ? 22 : 19, fontFamily: FontFamily.regular, fontWeight: '400' }}>Tap the{`  `}
                                    <CustomImage
                                        source={darkMode ? bookmarkIconLight : bookmarkIcon}
                                        require={true}
                                        style={{ width: helpers.isDesktop() ? 14 : 10, height: helpers.isDesktop() ? 19 : 16 }}
                                        webStyle={{ width: helpers.isDesktop() ? 14 : 10, height: helpers.isDesktop() ? 19 : 16 }}
                                        key={darkMode}
                                    />
                                    {`  `}icon on stories to save them for later</Text>
                            </View>
                        </View>
                    }
                </View>
                {data && data.length != 0 &&
                    <TouchableOpacityLink style={{ textAlign: 'center', paddingTop: 20 }} {...fullReadingListProp}>
                        <Text style={[Helpers.linkText, Helpers.textCenter, { color: '#FC876D', textDecorationColor: '#FC876D', letterSpacing: 0.5, fontFamily: FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 14, lineHeight: helpers.isDesktop() ? 22 : 18 }]}>See all my bookmarks</Text>
                    </TouchableOpacityLink>
                }
            </View>
        );
    }
}


export default AuthenticationWrapper(HomeReadingList);
